<template>
  <div>
    <vertical>
      <slot />
    </vertical>
  </div>
</template>

<script>
import Vertical from "./vertical";

export default {
  components: { Vertical },
  data() {
    return {};
  },

  methods: {},
};
</script>
